// utils/fileNameHelpers.ts
export function shortenFileName(fileName: string, maxLength = 10): string {
  if (!fileName) return "";

  const parts = fileName.split(".");
  const ext = parts.length > 1 ? parts.pop() : "";
  const base = parts.join("."); // handles names with multiple dots

  const truncated = base.slice(0, maxLength); // first N characters
  return `${truncated}xxx${ext ? "." + ext : ""}`;
}